<template>
    <div class="back" style="width: 100%;height: 100%;">
        <img src="../../src/assets/banner.png" class="login_pic" />
        <div class="login_card">
            <h1 class="login_head">{{title}}</h1>
            <el-form
                ref="loginForm"
                :rules="rules"
                :model="form"
            >
                <el-form-item prop="name">
                    <el-input
                        placeholder="账号"
                        class="loginInput"
                        prefix-icon="el-icon-user"
                        @keyup.enter.native="onSubmit"
                        v-model="form.name"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item prop="pwd">
                    <el-input
                        placeholder="密码"
                        class="loginInput"
                        prefix-icon="el-icon-lock"
                        v-model="form.pwd"
                        @keyup.enter.native="onSubmit"
                        show-password
                    ></el-input>
                </el-form-item>
                <el-form-item v-if="!hideType">
                    <el-radio class="login_radio" label="worker" v-model="userType"
                        >员工登录</el-radio
                    >
                    <el-radio class="login_radio" label="customer" v-model="userType"
                        >客户登录</el-radio
                    >
                </el-form-item>
                <div style="text-align: center">
                    <el-button
                        class="subBtn"
                        type="primary"
                        plain
                        @click="onSubmit"
                        >登录</el-button
                    >
                </div>
            </el-form>
        </div>
        <el-dialog :visible.sync="cmpDialog"  title="选择公司" width="30%" style="marginTop:20vh">
            <div class="login_btn">
                <el-select v-model="selectCmp" filterable>
                    <el-option
                        v-for="cc in company"
                        :key="cc.cmp"
                        :label="cc.name"
                        :value="cc.cmp"
                    ></el-option>
                </el-select>
            </div>
            <div class="login_btn">
                <el-button type="primary" @click="selectCompany(selectCmp)">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            cmpDialog:false,
            userType: "worker",
            hideType:false,
            form: {
                name: "",
                pwd: "",
            },
            selectCmp:'',
            company:[],
            title:'',

            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur",
                    },
                ],
                pwd: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                ],
            },
        };
    },
    created(){
        let cmp = this.$route.query.cmp;
        if(cmp>0){
            this.$global.cmpId.cmp = cmp;
            this.$api.getCompanyBasic().then(res=>{
                if(res.data.code==1){
                    let data = res.data.data;
                    this.title = data.ipadName?data.ipadName:'顺通ERP系统';
                    window.document.title = this.title;
                    let way = data.ipadWay;
                    if(way>0){
                        this.hideType = true;
                        if(way==2){
                            this.userType = "customer";
                        }
                    }
                }
            })
        }else{
            this.title = '顺通ERP系统';
            window.document.title = this.title;
            this.hideType = false;
            this.userType = "worker";
        }
    },
    methods: {
        onSubmit() {
            this.$refs["loginForm"].validate((valid) => {
                if (!valid) {
                    return false;
                }
                let data = {
                    username: this.form.name,
                    password: this.form.pwd,
                    type: this.userType == "worker" ? "0" : "1",
                };
                this.$api.tryLogin(data).then((res)=>{
                    let cmplist = res.data.data.data;
                    if(cmplist.length>1){
                        this.company = cmplist;
                        this.selectCmp = cmplist[0].cmp;
                        this.cmpDialog = true;
                    }else if(cmplist.length==1){
                        this.selectCompany(cmplist[0].cmp);
                    }else{
                        this.$common.error("此人不属于任何公司");
                    }
                })
            });
        },
        selectCompany:function(val){
            this.$global.cmpId.cmp = val;
            localStorage.setItem("cmp", val);
            this.login();
        },
        login(){
            let data = {
                username: this.form.name,
                password: this.form.pwd,
                type: this.userType == "worker" ? "0" : "1",
            };
            this.$api.login(data).then((res) => {
                let data = res.data.data;
                localStorage.removeItem('shopingcart');
                if (data.code == 1) {
                    if (this.userType == "worker") {
                        localStorage.setItem("token", data.token);
                        this.$global.name = data.name;
                        this.$global.userType = 0;
                        this.$global.id = data.id;
                    } else {
                        localStorage.setItem("token", data.token);
                        this.$global.name = data.username;
                        this.$global.userType = 1;
                        this.$global.id = data.id;
                    }
                    // this.$router.push({ path: "/" });
                    this.$router.push({
                        path: "/temp",
                        query:{url:'/'},
                    })
                } else {
                    this.$common.error(data.msg);
                }
                
            });
        }
    },
};
</script>

<style scoped>
.login_pic{
    width: 634px;
    height: 304px;
    float: right;
}
.subBtn {
    width: 90%;
    border-radius: 20px;
    color:#fff;
    background: linear-gradient(141deg,#2E6BE6,#1592FD);
}
.login_card{
    width: 320px;
    height: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
}
.login_head {
    font-size: 24px;
    line-height: 24px;
    font-weight: 500;
    padding-bottom: 30px;
    text-align: center;
    color: #010101;
}
.login_radio{
    width: 42%;
    display: inline-block;
    padding-left: 10px;
    color: #222 ;
    font-weight: bold !important;
}

.loginInput {
    width: 100%;
}

.login_btn{
    padding-top: 20px;
    display: flex;
    justify-content: center;
}
</style>
